export const STATUS = {
  NEW: 'NEW',
  INVITED: 'INVITED',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DELETED: 'DELETED',
  LOCKED: 'LOCKED',
  SUSPENDED: 'SUSPENDED',
  UNKNOWN: 'UNKNOWN',
  ALL: 'ALL'
};

export const STATUS_TO_SHOW_IN_ORDER = {
  ALL: STATUS.ALL,
  NEW: STATUS.NEW,
  INVITED: STATUS.INVITED,
  ACTIVE: STATUS.ACTIVE,
  INACTIVE: STATUS.INACTIVE,
  LOCKED: STATUS.LOCKED,
  SUSPENDED: STATUS.SUSPENDED
};

export const ROLE_STATUS = {
  ALL: STATUS.ALL,
  ACTIVE: STATUS.ACTIVE,
  INACTIVE: STATUS.INACTIVE
};

export const calculateStatus = status => {
  switch (status) {
    case STATUS.ACTIVE:
      return STATUS.ACTIVE;
    case STATUS.INACTIVE:
      return STATUS.INACTIVE;
    case STATUS.INVITED:
      return STATUS.INVITED;
    case STATUS.NEW:
      return STATUS.NEW;
    case STATUS.DELETED:
      return STATUS.DELETED;
    case STATUS.LOCKED:
      return STATUS.LOCKED;
    default:
      return STATUS.UNKNOWN;
  }
};
